//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'

import TwitchPreFlightCheck from 'core/components/twitch-pre-flight-check.vue'
import BlueskyIcon from './bluesky-icon'

export default {
    name: 'Footer',

    components: { BlueskyIcon },

    computed: {
        ...mapGetters(['gameId']),
    },

    methods: {
        goTwitch() {
            this.$present(TwitchPreFlightCheck)
        },
    },
}
